module.exports = __webpack_public_path__ + "img/hdc_05.c735dbf9.png";